import React, { useState } from 'react'
import { WhiteBox } from './AppShell'
import { makeStyles } from '@mui/styles'
import { Box, Paper, Typography } from '@mui/material'
import CustomButton from './CustomButtons'
import {  Session } from 'utils'
import { getResumeAnalysisHistory } from 'services/shortlistingTask'
import DynamicTable from './DynamicTable'
import { useTheme } from '@emotion/react'
import DownloadIcon from '@mui/icons-material/Download';

const useStyle = makeStyles(theme => ({
    borderBottom: {
        borderBottom: "1px solid #8692A3",
        paddingBottom: theme.spacing(1.5),
        width: "100%",
        display : 'flex',
        justifyContent : 'space-between'
      },
}))

const ShortlistScoreList = ({shortlistId}) => {
    const classes = useStyle();

    const [exportCsv, setExportCsv] = useState(false);
    const [initialFilters, setInitialFilters] = useState({
    shortlistTask : shortlistId,
    order: "desc",
    orderBy: "createdAt",
    // pageNumber: page + 1,
    // pageSize: pageSize,
    includeTotal: true,
    submitted : true
    });

  const columns = React.useMemo(() => ([
    { 
        field: "serialNumber", 
        label: "#", 
        minWidth: 80, 
        maxWidth: 100,
        align : 'center',
        disableSorting: true,
        renderCell: ({  index }) => index + 1
      },
    { 
        field: "name", 
        label: "Name", 
        minWidth: 150, 
        maxWidth: 200,
        align : 'center',
        disableSorting: true,
        renderCell: ({ row }) => row?.user?.name || ''
      },
    { 
        field: "email", 
        label: "Email", 
        minWidth: 150, 
        maxWidth: 200,
        align : 'center',
        disableSorting: true,
        renderCell: ({ row }) => row?.user?.email || ''
      },
    { 
      field: "score", 
      label: "Relevance score", 
      minWidth: 150, 
      maxWidth: 200,
      align : 'center',
      disableSorting: true,
    },
    { 
      field: "skillsScore", 
      label: "Skills match score", 
      minWidth: 150, 
      maxWidth: 200,
      align : 'center',
      disableSorting: true,
      renderCell: ({ row }) => row?.analysis?.skillMatchScore || 0
    },
    { 
      field: "experienceScore", 
      label: "Experience match score", 
      minWidth: 150, 
      maxWidth: 200,
      align : 'center',
      disableSorting: true,
      renderCell: ({ row }) => row?.analysis?.relevantExperienceScore || 0     
    },
    {
      id: "downloadResume",
      label: "Download resume", fixed: true,
      minWidth: 120, disableSorting: true,
      align: "center",
      renderCell: ({ row }) =>
        <DownloadIcon 
        sx={{ color: '#1961BF' }} 
        onClick={() => {
            window.location.href = `https://assets.languify.in/${row?.resume.path}`;    
        }} 
        />
    },
  ]), []);

  const handleExport = () => {
    setExportCsv(true); 
    };
    const handleCsvExportSuccess = () => {
        setExportCsv(false);
    };

  return (
    <WhiteBox>
        <Box className={classes.borderBottom}>
            <Box display='flex' flexDirection='column'>
                <Typography variant="h4-medium">
                    Shortlisting scoreboard
                </Typography>
                <Typography variant="body01-bold" color='neutral.clr-600'>
                    Insights into your batch’s shortlisting performance
                </Typography>
            </Box>
            <CustomButton onClick={handleExport}>
                Export performance
            </CustomButton>
        </Box>
        <Paper elevation={0} style={{ width: "100%" , marginTop : '12px' }}>
            <DynamicTable
                hideDeleteAction
                entity="Tasks"
                noRowsMessage='You have not submitted any shortlist so far! Once submitted you can see in this section'
                columns={columns}
                sx={{ p: 0 }}
                useListProps={{
                getItems: getResumeAnalysisHistory,
                itemName: 'resumeInsights',
                initialFilters: initialFilters,
                }}
                enableCsvExport={exportCsv}
                onCsvExportSuccess={handleCsvExportSuccess}
                quickSearchField={false}
            />
        </Paper>
    </WhiteBox>
  )
}

export default ShortlistScoreList